import { render } from "./EpisodeCategories.vue?vue&type=template&id=1aad6e64&scoped=true"
import script from "./EpisodeCategories.vue?vue&type=script&lang=js"
export * from "./EpisodeCategories.vue?vue&type=script&lang=js"

import "./EpisodeCategories.vue?vue&type=style&index=0&id=1aad6e64&scoped=true&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aad6e64"]])

export default __exports__